import React from "react";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { Typography, Box, Stack, Divider } from "@mui/material";
import { IMultipleEvent } from "../../../../redux/leads/leads.types";

interface IUpdateEventDialogProps {
  onClose: () => void;
  onConfirmClick: () => void;
  updatedEventValues: IMultipleEvent;
}

const RowItem = ({
  label,
  value,
}: {
  label: string;
  value?: string | number;
}) => (
  <Stack direction="row" spacing={1}>
    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 170 }}>
      {label}:
    </Typography>
    <Typography variant="body2" fontWeight={500}>
      {value || "-"}
    </Typography>
  </Stack>
);

export const UpdateEventDialog: React.FC<IUpdateEventDialogProps> = ({
  onClose,
  onConfirmClick,
  updatedEventValues,
}) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      title="Do you want to update an event?"
      size="sm"
      actions={[
        {
          type: "button",
          label: "Cancel",
          variant: "text",
          onClick: onClose,
        },
        {
          type: "button",
          label: "Yes, Confirm",
          variant: "contained",
          onClick: onConfirmClick,
        },
      ]}
    >
      <Box px={1} py={0.5}>
        <Stack spacing={2}>
          {/* Info Section */}
          <Box
            sx={{
              backgroundColor: "#f9fafb",
              borderRadius: "10px",
              padding: "12px 16px",
              border: "1px solid #e5e7eb",
            }}
          >
            <Stack spacing={1.5}>
              <RowItem
                label="Selected function date"
                value={updatedEventValues?.function_date || "--"}
              />
              <RowItem
                label="Selected function month"
                value={updatedEventValues?.function_month || "--"}
              />
              <RowItem
                label="Selected Venue name"
                value={updatedEventValues?.preferred_venue || "--"}
              />
              <RowItem
                label="Selected Event time"
                value={updatedEventValues?.event_time || "--"}
              />
            </Stack>
          </Box>

          {/* Optional subtle helper text */}
          <Divider />

          <Typography
            variant="caption"
            color="text.secondary"
            textAlign="center"
          >
            Please confirm to apply these changes to the event.
          </Typography>
        </Stack>
      </Box>
    </Dialog>
  );
};
